import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "src/environments/environment";
import { Note, UpdateNoteSubject } from "./note-models";
import { Subject } from "rxjs";
import { DashboardStore } from "src/app/dashboard/dashboard.store";

@Injectable({
  providedIn: "root",
})
export class NotesService {
  updateNoteSubject: Subject<UpdateNoteSubject> = new Subject();
  deleteNoteSubject: Subject<Note> = new Subject();
  hideEditModalSubject: Subject<boolean> = new Subject();

  constructor(
    private http: HttpClient,
    private dashboardStore: DashboardStore,
  ) {}

  createNewNote(companyUuid: string, note: Note): Promise<any> {
    const url = `${environment.apiUrl}/company/${companyUuid}/notes`;
    return this.http.post(url, note).toPromise();
  }

  deleteNote(companyUuid: string, noteUuid: string): Promise<any> {
    const url = `${environment.apiUrl}/company/${companyUuid}/notes/${noteUuid}`;
    return this.http.delete(url).toPromise();
  }

  updateNote(
    companyUuid: string,
    noteUuid: string,
    updatedNote: Note,
  ): Promise<any> {
    const url = `${environment.apiUrl}/company/${companyUuid}/notes/${noteUuid}`;
    return this.http.put(url, updatedNote).toPromise();
  }

  updateClientInformation(
    companyUuid: string,
    updatedClientInformation: string,
  ): Promise<any> {
    const url = `${environment.apiUrl}/company/${companyUuid}/update-client-information`;

    return this.http.put(url, { updatedClientInformation }).toPromise();
  }

  getAllNotes(companyUuid: string): Promise<any> {
    const url = `${environment.apiUrl}/company/${companyUuid}/notes`;
    return this.http.get(url).toPromise();
  }
  getCompanyUuid(companyId: number): Promise<any> {
    const client = this.dashboardStore.all_clients.find(
      (c) => c.id == companyId,
    );
    if (client?.uuid) {
      return Promise.resolve({ uuid: client.uuid });
    }

    const url = `${environment.apiUrl}/company/${companyId}/company-uuid`;
    return this.http.get(url).toPromise();
  }
}
